import React, {useEffect} from 'react';
import Table from 'react-bootstrap/Table';
import LinkolnEmail from './LinkolnEmail';
import { useStoreActions, useStoreState } from "easy-peasy";
import { withRouter } from 'react-router-dom';


function LinkolnEmails () {
  const is_logged_in = useStoreState(state => state.is_logged_in);
  const linkoln_emails = useStoreState(state => state.linkoln_emails.linkoln_emails);
  const domain = useStoreState(state => state.current_domain);
  const account_id = useStoreState(state => state.account_id);
  const get_linkoln_emails = useStoreActions(actions => actions.linkoln_emails.getLinkolnEmails);

  useEffect(() => {
    if (is_logged_in) {
      get_linkoln_emails(domain.domain);
    }
  }, [domain, get_linkoln_emails, is_logged_in, account_id]);

  return (
    <div className="container px-0">
        <div className="row">
        <div className="col-12">
        <h2>Messages</h2>
        <h3>It’s time to create your very own LINKOLN Email!</h3>
        Just send an email to: <a href="mailto:create@linkoln.email">create@linkoln.email</a>
        <p>Seriously, it can be anything you like, your pet's name, your favorite food, you name it! This ain't your grandma's email setup – no forms, no fuss.</p>
        <p>Just a single email, and your unique LINKOLN Email link is ready to rock. Hit us up, let's turn 'anything' into your extraordinary</p>
        <p>Simplify your communication with secure message links. No more complicated email threads or inboxes. Just simple and secure message links that anyone can use. </p>

        <Table striped bordered responsive>
          <tbody>
          {linkoln_emails.map(linkoln_email => (
            <LinkolnEmail
              linkoln_email={linkoln_email}
              key={linkoln_email.linkoln_email_id}
            />
          ))}
          </tbody>
        </Table>
        <p><strong>Coming soon…</strong> individual message history and activity reporting.</p>
      </div>
      </div>
    </div>
  );
}

export default withRouter(LinkolnEmails);
